import { httpApi } from '@app/api/http.api';
import { SketchMeExampleCategory, SketchMeExampleModel, SketchMeExampleStyle } from '@app/domain/SketchMeExampleModel';

export const EXAMPLE_CATEGORIES: SketchMeExampleCategory[] = [
  'Portrait',
  'Figure',
  'Animal',
  'Architecture',
  'Landscape',
  'Object',
];

export const EXAMPLE_STYLES: SketchMeExampleStyle[] = ['Pencil'];

export interface ExampleListResponse {
  data: SketchMeExampleModel[];
  total: number;
}

/**
 * Creates a new sketch-me example tutorial. Generation is asynchronous (takes a little
 * while) — the backend answers 202 with the created tutorial in `pending` status.
 * `formData` must contain: photo (File) and name. Category and style are no longer chosen
 * in the CMS (client asked for those fields to go) — the backend defaults them.
 */
export const createExample = (formData: FormData): Promise<SketchMeExampleModel> =>
  httpApi.post<SketchMeExampleModel>('ai-draw/admin/examples', formData).then(({ data }) => data);

export const getExamples = (): Promise<ExampleListResponse> =>
  httpApi.get<ExampleListResponse>('ai-draw/admin/examples').then(({ data }) => data);

export const getExample = (id: number | string): Promise<SketchMeExampleModel> =>
  httpApi.get<SketchMeExampleModel>(`ai-draw/admin/examples/${id}`).then(({ data }) => data);

export const deleteExample = (id: number | string): Promise<void> =>
  httpApi.delete(`ai-draw/admin/examples/${id}`).then(() => undefined);
